import { AloftPrice } from '@aloft/toolkit-shared';

export type AdjustedSalePriceRangeTier = {
  anchor: AloftPrice;
  threshold: number;
};

export const ADJUSTED_SALE_PRICE_RANGE_TIERS: readonly AdjustedSalePriceRangeTier[] = [
  { anchor: AloftPrice.fromDollarLike(250_000), threshold: 0.18 },
  { anchor: AloftPrice.fromDollarLike(500_000), threshold: 0.2 },
  { anchor: AloftPrice.fromDollarLike(1_000_000), threshold: 0.23 },
  { anchor: AloftPrice.fromDollarLike(2_000_000), threshold: 0.29 },
  { anchor: AloftPrice.fromDollarLike(5_000_000), threshold: 0.35 },
];

export const getAdjustedSalePriceRangeTier = (average: AloftPrice): AdjustedSalePriceRangeTier => {
  const averageDollars = average.toDollarLike();

  return ADJUSTED_SALE_PRICE_RANGE_TIERS.reduce((nearest, tier) => {
    const nearestDistance = Math.abs(averageDollars - nearest.anchor.toDollarLike());
    const tierDistance = Math.abs(averageDollars - tier.anchor.toDollarLike());
    if (tierDistance < nearestDistance) return tier;
    if (
      tierDistance === nearestDistance &&
      tier.anchor.toDollarLike() < nearest.anchor.toDollarLike()
    ) {
      return tier;
    }
    return nearest;
  });
};
